import type { DropTargetMonitor, XYCoord } from 'react-dnd';

/**
 * Determine where or not to update indexes during drag
 *
 * This is a part of algorithm for handling useDrag:hover taken from documentation https://github.com/react-dnd/react-dnd/blob/09838c9c203554bfe23c97f7af82b120f7f28be8/packages/documentation/examples-hooks/src/04-sortable/simple/Card.tsx
 * The implementation is a bit cryptic, it would be nice to improve the docs here one day.
 */
export const canSort = (
  container: HTMLDivElement,
  monitor: DropTargetMonitor,
  dragIndex: number,
  hoverIndex: number,
): boolean => {
  // Determine rectangle on screen
  const hoverBoundingRect = container.getBoundingClientRect();

  // Get vertical middle
  const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

  // Determine mouse position
  const clientOffset = monitor.getClientOffset();

  // Get pixels to the top
  const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top;

  // Dragging downwards
  if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
    return false;
  }

  // Dragging upwards
  if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
    return false;
  }

  return true;
};
